import { __rest } from "tslib";
import React from 'react';
import { Label, Text } from '@gravity-ui/uikit';
import cloneDeep from 'lodash/cloneDeep';
import { block } from '../../../utils';
import { LazyLoader } from '../../LazyLoader';
import { loadIcon } from './utils';
import './TextContent.css';
const b = block('text-content');
export const TextContent = (_a) => {
    var _b;
    var { spec, Layout, input } = _a, restProps = __rest(_a, ["spec", "Layout", "input"]);
    const { textContentParams, layoutDescription } = spec.viewSpec;
    const text = React.useMemo(() => ((textContentParams === null || textContentParams === void 0 ? void 0 : textContentParams.text) ? textContentParams === null || textContentParams === void 0 ? void 0 : textContentParams.text : layoutDescription), [layoutDescription, textContentParams === null || textContentParams === void 0 ? void 0 : textContentParams.text]);
    if (!text) {
        return null;
    }
    const iconLib = (textContentParams === null || textContentParams === void 0 ? void 0 : textContentParams.icon) ? (React.createElement(LazyLoader, { component: loadIcon(textContentParams === null || textContentParams === void 0 ? void 0 : textContentParams.icon) })) : null;
    let content = React.createElement("span", { dangerouslySetInnerHTML: { __html: text } });
    if (textContentParams === null || textContentParams === void 0 ? void 0 : textContentParams.themeLabel) {
        content = (React.createElement(Label, { size: "m", theme: textContentParams.themeLabel, className: b(), value: input.value, icon: iconLib }, content));
    }
    else {
        content = (React.createElement("div", { className: b('wrapper') },
            iconLib ? (React.createElement(Text, { color: (_b = spec.viewSpec.textContentParams) === null || _b === void 0 ? void 0 : _b.iconColor, className: b('icon') }, iconLib)) : null,
            content,
            input.value ? (React.createElement(React.Fragment, null,
                React.createElement(Text, { className: b('separator') }, ":"),
                React.createElement(Text, { color: "secondary" }, input.value))) : null));
    }
    if (Layout) {
        const _spec = cloneDeep(spec);
        if (!(textContentParams === null || textContentParams === void 0 ? void 0 : textContentParams.text)) {
            _spec.viewSpec.layoutDescription = undefined;
        }
        return (React.createElement(Layout, Object.assign({ spec: _spec, input: input }, restProps), content));
    }
    return content;
};
